import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class AdminroleService extends GenericService {
  constructor() {
    super('/roles', axiosInstance);
  }
}

export default new AdminroleService(); 